import * as yup from "yup";

import * as RHFWishListValidationRules from "@/utils/validation/schemas/wishlist.RHF";

export const WishlistTitleRenameFormValidationSchema = yup.object({
    name: RHFWishListValidationRules.wishlistName
});

export type WishlistTitleRenameFormValues = yup.InferType<
    typeof WishlistTitleRenameFormValidationSchema
>;
